import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule, MatGridListModule } from '@angular/material';

import {
    ContentHeaderComponent,
    ContentListComponent,
    ModalConfirmComponent,
    LoadingComponent,
    ModalLogoutComponent
} from './components';

import {
    AppExpandMenu,
    AppExpandSidebar,
    FilterGeneralPipe,
    SearchPipe,
    OrderByPipe
} from './pipes';
import { RequestErrorComponent } from './components/request-error/request-error.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { LoadingPageComponent } from './components/loading-page/loading-page.component';
import { RouterModule } from '@angular/router';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { ModuleItemComponent } from './components/module-item/module-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { ChapterItemComponent } from './components/chapter-item/chapter-item.component';
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component';
import { ConfirmComponent } from './modals/confirm/confirm.component';
import { EvidenceItemComponent } from './components/evidence-item/evidence-item.component';
import { TakerComponent } from './modals/taker/taker.component';
import { ReportComponent } from './components/report/report.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';

@NgModule({
    imports: [
        CommonModule,
        AngularFontAwesomeModule,
        FormsModule,
        ReactiveFormsModule,
        MatExpansionModule,
        MatGridListModule,
        RouterModule,
        TranslateModule
    ],
    declarations: [
        ModalLogoutComponent,
        AppExpandMenu,
        AppExpandSidebar,
        ContentHeaderComponent,
        ContentListComponent,
        FilterGeneralPipe,
        SearchPipe,
        ModalConfirmComponent,
        OrderByPipe,
        LoadingComponent,
        RequestErrorComponent,
        BreadcrumbsComponent,
        LoadingPageComponent,
        MenuItemComponent,
        ModuleItemComponent,
        ChapterItemComponent,
        LoadingBarComponent,
        ConfirmComponent,
        EvidenceItemComponent,
        TakerComponent,
        ReportComponent,
        LoadingSpinnerComponent
    ],
    exports: [
        ModalLogoutComponent,
        AppExpandMenu,
        AppExpandSidebar,
        ContentHeaderComponent,
        ContentListComponent,
        FilterGeneralPipe,
        SearchPipe,
        ModalConfirmComponent,
        OrderByPipe,
        LoadingComponent,
        RequestErrorComponent,
        BreadcrumbsComponent,
        LoadingPageComponent,
        MenuItemComponent,
        ModuleItemComponent,
        ChapterItemComponent,
        LoadingBarComponent,
        ConfirmComponent,
        EvidenceItemComponent,
        TakerComponent,
        ReportComponent,
        LoadingSpinnerComponent
    ],
    entryComponents: [
        // ModalLogoutComponent,
        ModalConfirmComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class SharedModule {}
